import { render, staticRenderFns } from "./SILA_PDF_Viewer.vue?vue&type=template&id=7019de13&scoped=true&"
import script from "./SILA_PDF_Viewer.vue?vue&type=script&lang=js&"
export * from "./SILA_PDF_Viewer.vue?vue&type=script&lang=js&"
import style0 from "./SILA_PDF_Viewer.vue?vue&type=style&index=0&id=7019de13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7019de13",
  null
  
)

export default component.exports